module.exports = __webpack_public_path__ + "img/border-center-h.7742c1c2.svg";